import { gql } from '@apollo/client';

const Fragments = {
  reportVerification: gql`
    fragment reportVerification on ReportVerification {
      id
      createdDate
      service
      method
      externalId
      entityName
      userName
      extended {
        status
        orderId
        documentNumber
        reused
      }
    }
  `
};

export default Fragments;
